var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsThreeVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 15.9987C17.3333 15.2623 16.7363 14.6654 16 14.6654C15.2636 14.6654 14.6666 15.2623 14.6666 15.9987C14.6666 16.7351 15.2636 17.332 16 17.332C16.7363 17.332 17.3333 16.7351 17.3333 15.9987Z",
    stroke: "#343330",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 6.66667C17.3333 5.93029 16.7363 5.33333 16 5.33333C15.2636 5.33333 14.6666 5.93029 14.6666 6.66667C14.6666 7.40305 15.2636 8 16 8C16.7363 8 17.3333 7.40305 17.3333 6.66667Z",
    stroke: "#343330",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 25.3346C17.3333 24.5983 16.7363 24.0013 16 24.0013C15.2636 24.0013 14.6666 24.5983 14.6666 25.3346C14.6666 26.071 15.2636 26.668 16 26.668C16.7363 26.668 17.3333 26.071 17.3333 25.3346Z",
    stroke: "#343330",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsThreeVertical);
export default __webpack_public_path__ + "static/media/dots-three-vertical.6f934a10efde04b0aa9ebf7bc8d8ade8.svg";
export { ForwardRef as ReactComponent };